import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import LogBase from "./_LogBase.vue";

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const columns = [
  { prop: "received_date", label: "Огноо" },
  { prop: "patch_id", label: "Patch ID" },
  { prop: "patch_number", label: "Patch №" },
  { prop: "data_provider_regnum", label: "Нийлүүлэгч" },
  { prop: "data_provider_branch", label: "Салбар" },
  { prop: "file_path", label: "Файл" },
  { prop: "file_size", label: "Хэмжээ" },
  { prop: "username", label: "Хэрэглэгч" },
  { prop: "status", label: "Статус" },
  { prop: "ip_address", label: "IP" },
  { prop: "action", label: "Action" }
];

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(LogBase, {
    title: "JSON хүлээн авсан лог",
    endpoint: "/logs/patch",
    columns: columns,
    show: { provider: true, branch: true, patch: true }
  }))
}
}

})